import { global } from "../../constants";

export const data = {
  banner: {
    base: "服务",
    background: global.banner + "tax-law.webp",
    title: "税法",
    crumb: "税法",
  },
  icon: "fa-solid fa-scale-balanced",
  shortDescription:
    "为海事、港口和外贸企业提供全面税务咨询：税务优化、激励措施和合规管理。",

  title: "税法",
  features: {
    title: "税法",
    deliverables: "交付物",
    reqDocuments: "所需文件",
    subtitle:
      "针对海事和物流行业的税务义务、激励措施和海关规划的战略分析。",
    description: `针对海事和港口行业的所得税、增值税、附加税和社会保障的专业税务咨询。我们评估业务模式、运营地点（自由区/经济特区）、正式义务、激励措施和国际方案（如适用），制定符合运营和监管风险的合规与税务优化计划。`,
    viewDetail: "查看详情",
    feats: [
      {
        key: "actividad",
        title: "识别经济活动类型和商业模式",
        summary:
          "我们对活动进行分类（海运、代理、装卸、物流、离岸服务），以确定适用的税收处理方式。",
        details:
          "我们对商业模式进行诊断，以识别收入性质及其税收归类：受所得税征税的活动、受增值税征税或免税的操作、运费、佣金和相关服务的收入处理。此分析是定义税收制度、预扣义务和会计手续的基础。",
        deliverables: [
          "经济分类与税务风险报告",
          "收入流及其税收处理图",
          "发票和合同结构建议"
        ],
        requiredDocs: [
          "公司宗旨和章程",
          "商业和租船合同",
          "代表性账单和发票"
        ],
        icon: "fa-solid fa-briefcase",
        image: global.services + "tax_law/1.webp",
      },
      {
        key: "ubicacion",
        title:
          "地理位置及其税收影响评估（自由区/经济特区）",
        summary:
          "我们根据运营地点（自由区、经济特区、国内港口）分析税收和海关影响，识别激励措施和要求。",
        details:
          "我们确定操作是否可享受特殊制度（经济特区/自由区）、获得优惠（增值税/所得税减免、退税、加速折旧）的条件及正式要求。还评估相关海关义务和退税或关税返还的好处。",
        deliverables: [
          "经济特区/自由区资格报告",
          "激励措施准入要求清单",
          "区域实施计划"
        ],
        requiredDocs: [
          "税务和运营地址",
          "港口许可证和执照",
          "进出口文件"
        ],
        icon: "fa-solid fa-location-dot",
        image: global.services + "tax_law/2.webp",
      },
      {
        key: "tributos",
        title: "适用的直接和间接税收确定（增值税、所得税、INCES、IVSS等）",
        summary:
          "我们识别并量化影响企业运营的税收和附加税。",
        details:
          "我们编制矩阵，将每一项收入/支出与其对应的税收关联：增值税处理（征税或免税）、所得税规则（计税基础、预扣和预付）、INCES（缴款）和IVSS义务，以及其他地方或特殊税收。包括合规和优化建议，确保符合法律框架和适当的会计记录。",
        deliverables: [
          "按运营流程适用税收汇总表",
          "年度税负模拟",
          "预扣和预付计算程序"
        ],
        requiredDocs: [
          "近期税务申报表",
          "会计账簿和销售/采购记录",
          "代表性合同和发票"
        ],
        icon: "fa-solid fa-coins",
        image: global.services + "tax_law/3.webp",
      },
      {
        key: "obligaciones",
        title: "正式义务的确定：会计账簿、申报和预扣",
        summary:
          "我们对SENIAT及相关机构的正式义务进行审计和定义：账簿、定期申报和预扣。",
        details:
          "我们审查法规要求的账簿和记录、月度/年度申报义务（增值税/所得税）、会计对账和供应商及员工的预扣程序。我们准备模板、日历和内部指南，以降低罚款和行政处罚风险。",
        deliverables: [
          "正式合规清单和税务日历",
          "账簿和报告模板（电子/纸质）",
          "预扣程序和审计支持"
        ],
        requiredDocs: [
          "会计账簿和记录",
          "预扣收据和支持文件",
          "内部控制政策"
        ],
        icon: "fa-solid fa-file-invoice-dollar",
        image: global.services + "tax_law/4.webp",
      },
      {
        key: "incentivos",
        title: "税收激励措施的应用及扣除和抵免规划",
        summary:
          "我们发现适用的激励措施、免税和扣除，并设计合法利用的方案。",
        details:
          "我们分析可用的激励措施（经济特区、所得税/增值税退税、加速折旧、投资激励），并提出最大化扣除和税收抵免的文件和流程建议。包括准备免税申请和与主管部门的跟进（如适用）。",
        deliverables: [
          "适用激励措施清单及估算",
          "免税申请和支持模板",
          "年度税务优化计划"
        ],
        requiredDocs: [
          "财务报表",
          "投资和可扣除费用凭证",
          "区域或特殊制度证书（如适用）"
        ],
        icon: "fa-solid fa-hand-holding-dollar",
        image: global.services + "tax_law/5.webp",
      },
      {
        key: "planificacion",
        title: "国际结构和海关策略评估",
        summary:
          "我们研究国际结构（控股、子公司）的必要性，并设计海关策略以优化成本和合规性。",
        details:
          "我们进行国际规划分析，考虑现行的双重征税协定及中间公司（控股）或子公司的便利性。我们制定进出口海关策略（制度、简化清关、退税），在适用法律框架内最大限度地降低风险和物流及税务成本。",
        deliverables: [
          "国际结构便利性评估",
          "国际税务风险地图",
          "运营与合规海关计划"
        ],
        requiredDocs: [
          "当前公司结构",
          "国际合同和进出口发票",
          "以往海关文件"
        ],
        icon: "fa-solid fa-globe",
        image: global.services + "tax_law/6.webp",
      }
    ],
  },
  ctaText: "申请税务咨询",
  ctaLink: "/contact?service=tax-law",
};
